import { Directive, Input, ElementRef, NgZone, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[ThumnaildragNdrop]'
})
export class ThumnaildragNdrop {
    @Input('ThumnaildragNdrop') data: any;//data    
    @Output() drop: EventEmitter<any> = new EventEmitter();
    dragelElement: any = null;
    // drag n drop mouse event
    offsetX: number = 0;
    offsetY: number = 0;
    oldElement: any = null;
    IsMoveable: boolean = false;
    //timer: any;   
    constructor(private _elementRef: ElementRef, private ngZone: NgZone) {
    }
    ngOnInit() {
        // Get the current element
        let el = this._elementRef.nativeElement;
        this.dragelElement = null;
        //month view        
        this.ngZone.runOutsideAngular(() => {
            var object = this;
            el.addEventListener('mousedown', (e) => {
                var target = e.target != null ? e.target : e.srcElement;
                if (target.classList.contains('drag')) {
                    target = target;
                }
                else if (target.parentElement.classList.contains('drag')) {
                    target = target.parentElement;
                }
                else if (target.parentElement.parentElement.classList.contains('drag')) {
                    target = target.parentElement.parentElement;
                }
                if (target.classList.contains('drag')) {
                    this.oldElement = target;
                    this.offsetX = this.ExtractNumber(target.style.left);
                    this.offsetY = this.ExtractNumber(target.style.top);
                    var newelem = target.cloneNode(true);
                    newelem.className += " draggedElement thumnail_dragndrop userSelectdisable";
                    newelem.style.display = "none";
                    // newelem.innerHTML += "<div id='hoverslot' class='CustomViewhoverslot'></div>";
                    document.body.appendChild(newelem);
                    this.dragelElement = newelem;
                    document.body.focus();
                    object = this;
                    var movetimer = 0;
                    document.onmousemove = function (ev) {
                        ev.preventDefault();
                        movetimer++;
                        if (object.oldElement != null && object.dragelElement != null && movetimer > 3) {
                            if (object.oldElement.style.display == "block" || object.oldElement.style.display == "") {
                                object.oldElement.style.display = "none";
                                object.dragelElement.style.display = "block";
                            }
                            if (!object.IsMoveable) {
                                object.IsMoveable = true;
                            }
                            object.dragelElement.style.left = ((ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft) + 10) + 'px';
                            object.dragelElement.style.top = ((ev.clientY + document.body.scrollTop + document.documentElement.scrollTop) + 5) + 'px';
                        }
                        return true;
                    };
                    document.onmouseover = function (ev) {
                        ev.preventDefault();
                        if (object.IsMoveable && object.dragelElement != null) {
                            // var elemover = document.getElementById("hoverslot");
                            var cevent: any = ev.target;
                            if (cevent && cevent.classList && cevent.classList != "") {
                                if (cevent.classList.contains('thumnail_drop')) {
                                    cevent.classList.add("thumnail_drop_hover");
                                }
                            }
                        }
                        else
                            return true;
                        return true;
                    };
                    document.onmouseout = function (ev) {
                        ev.preventDefault();
                        if (object.IsMoveable && object.dragelElement != null) {
                            // var elemover = document.getElementById("hoverslot");
                            // elemover.innerHTML = "";
                        }
                        var cevent: any = ev.target;
                        let image_box = cevent.classList.contains('thumnail_drop') || cevent.parentElement.classList.contains('thumnail_drop')

                        if (image_box) {
                            cevent.classList.remove("thumnail_drop_hover");
                        }

                        //clearInterval(object.timer);
                        return true;
                    };
                    document.onmouseup = function (ev) {
                        ev.preventDefault();
                        debugger;
                        if (object.dragelElement != null) {

                            // we're done with these events until the next OnMouseDown
                            document.onmousemove = null;
                            //document.onselectstart = null;
                            document.onselect = null;
                            document.onmouseover = null;
                            document.onmouseout = null;
                            document.onmousedown = null;
                            object.dragelElement.ondragstart = null;
                            object.dragelElement = null;
                            object.IsMoveable = false;
                            document.onmouseup = null;
                            var cevent: any = ev.target;


                            if (cevent.classList.contains('emptyCell')) {
                                cevent.classList.remove("emptycellhover");
                                object.dropfuc(cevent, "assignjob");
                            }
                            else if (cevent.classList.contains('availableContainer')) {
                                cevent.classList.remove("de_allocated_area");
                                object.dropfuc(cevent, "unassignjob");
                            }
                            else if (cevent.parentElement.classList.contains('availableContainer')) {
                                cevent.parentElement.classList.remove("de_allocated_area");
                                object.dropfuc(cevent, "unassignjob");
                            }
                            else if (cevent.parentElement.parentElement.classList.contains('availableContainer')) {
                                cevent.parentElement.parentElement.classList.remove("de_allocated_area");
                                object.dropfuc(cevent, "unassignjob");
                            }

                            else {
                                object.oldElement.style.display = "block";
                                var draggitem = document.getElementsByClassName("draggedElement");
                                for (let i = draggitem.length - 1; i >= 0; i--) {
                                    draggitem[i].parentNode.removeChild(draggitem[i]);
                                }
                            }

                            object.oldElement = null;
                            //clearInterval(object.timer);
                        }
                        return true;
                    };
                    return true;
                }
                return true;
            });
        });
    }
    ExtractNumber(value) {
        var n = parseInt(value);
        return n == null || isNaN(n) ? 0 : n;
    }
    dropfuc(obj: any, area: string) {
        let slotid = obj.getAttribute("DropData");
        this.drop.emit({ available: this.data, alloted: slotid, area: area });
        return true;
    }
    ngOnDestroy() {

    }
}